export default "__VITE_ASSET__50c5153e__"